import { Headers } from './Headers'

class HttpResponse<T = any> {
    constructor(public response: T, public status:number, public headers?: Headers) {
    }
}

export default HttpResponse
